import { css } from "@emotion/core";
import { color, fontWeight } from "../../constants/commons";

export const congratulationsPageStyle = css`
  .page-container-style {
    position: absolute;
    top: 2%;
    height: 100%;
    width: 100%;
    margin: 0 15em;
  }
  .horizontal-line-style {
    border: 0.0625em solid ${color.gray};
    height: 0.0625em;
    width: 100%;
  }
  .checkbox-label {
    color: ${color.lightishGray};
  }
  .accept-button-style {
    width: 100%;
  }
  .close-mark-container {
    background: ${color.backgroundGray};
    border-radius: 50%;
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .smiley-image-container {
    background: ${color.whitishGray};
    height: 3.45em;
    width: 3.45em;
    border-radius: 50%;
  }
  .heading-style {
    color: ${color.lightishBlue};
    font-weight: ${fontWeight.light};
  }
  .terms-style {
    color: ${color.red};
    font-family: ${fontWeight.bold};
    font-weight: ${fontWeight.medium};
    text-transform: uppercase;
  }
  .contract-background {
    background: ${color.whitishGray};
    border-radius: 0.625em;
    height: 30em;
    overflow: scroll;
    padding: 1em;
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .congratulations-screen-responsive-container {
      margin: 3em 0em;
    }
    .document-container {
      margin-bottom: 2em;
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .congratulations-screen-responsive-container {
      margin: 0 4em;
    }
    .document-container {
      margin-bottom: 4em;
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .congratulations-screen-responsive-container {
      margin: 0 8em;
    }
    .document-container {
      margin-bottom: 6em;
    }
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .congratulations-screen-responsive-container {
      margin: 0 12em;
    }
    .document-container {
      margin-bottom: 8em;
    }
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .congratulations-screen-responsive-container {
      margin: 0 10em;
    }
    .document-container {
      margin-bottom: 8em;
    }
  }
`;
